"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const authored_columns_1 = require("../../../../composite/evidence/authored-evidence/authored-columns");
const table_cells_1 = require("../../../../composite/table/table-cells");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const { authoredColumns } = (0, authored_columns_1.useAuthoredColumns)();
    return [
        {
            datakey: 'service',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_SERVICE',
                defaultMessage: 'Služba',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'localPart',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_LOCAL_PART',
                defaultMessage: 'Operace',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'duration',
            name: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_COLUMN_DURATION',
                defaultMessage: 'Trvání',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.NumberCell,
            sortable: true,
            filterable: true,
        },
        ...authoredColumns,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=messages-columns.js.map